module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASUlEQVQ4y2P4jwQ+MAww7wADDNgPCh7QVX8GB48ZEkaDggcC/H8YBgMPyAAmHOb/g4EHDCVkdw4oD+wyeIwNLG/AczGCN3jKOgA+WtzlceUmOQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xNlQxNzoxODoxMSswOTowMDtc+lcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00005_100x100.png
// module id = y3uO
// module chunks = 0